var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMosaicIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73223 1.73223C1.26339 2.20107 1 2.83696 1 3.5V6C1 6.66304 1.26339 7.29893 1.73223 7.76777C2.20107 8.23661 2.83696 8.5 3.5 8.5H6C6.66304 8.5 7.29893 8.23661 7.76777 7.76777C8.23661 7.29893 8.5 6.66304 8.5 6V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1H3.5C2.83696 1 2.20107 1.26339 1.73223 1.73223Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2322 1.73223C13.7634 2.20107 13.5 2.83696 13.5 3.5V6C13.5 6.66304 13.7634 7.29893 14.2322 7.76777C14.7011 8.23661 15.337 8.5 16 8.5H18.5C19.163 8.5 19.7989 8.23661 20.2678 7.76777C20.7366 7.29893 21 6.66304 21 6V3.5C21 2.83696 20.7366 2.20107 20.2678 1.73223C19.7989 1.26339 19.163 1 18.5 1H16C15.337 1 14.7011 1.26339 14.2322 1.73223Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73223 14.2322C1.26339 14.7011 1 15.337 1 16V18.5C1 19.163 1.26339 19.7989 1.73223 20.2678C2.20107 20.7366 2.83696 21 3.5 21H6C6.66304 21 7.29893 20.7366 7.76777 20.2678C8.23661 19.7989 8.5 19.163 8.5 18.5V16C8.5 15.337 8.23661 14.7011 7.76777 14.2322C7.29893 13.7634 6.66304 13.5 6 13.5H3.5C2.83696 13.5 2.20107 13.7634 1.73223 14.2322Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2322 14.2322C13.7634 14.7011 13.5 15.337 13.5 16V18.5C13.5 19.163 13.7634 19.7989 14.2322 20.2678C14.7011 20.7366 15.337 21 16 21H18.5C19.163 21 19.7989 20.7366 20.2678 20.2678C20.7366 19.7989 21 19.163 21 18.5V16C21 15.337 20.7366 14.7011 20.2678 14.2322C19.7989 13.7634 19.163 13.5 18.5 13.5H16C15.337 13.5 14.7011 13.7634 14.2322 14.2322Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicIconWhite);
export default __webpack_public_path__ + "static/media/mosaic-icon-white.713f91898792d3296c38ec35e16b7120.svg";
export { ForwardRef as ReactComponent };